/* eslint-disable sonarjs/no-duplicate-string */
import Vue from 'vue'
import Router from 'vue-router'
import Config from '@/config'
import store from '@/vuex/store'

// services
import cookie from '@/services/cookie'
import zoho from '@/services/zoho'
import util from '@/util'
import mixpanelUtils from './utils/mixpanel.utils'

Vue.use(Router)

const configRouter = {
  mode: 'history',
  linkExactActiveClass: 'selected',
  linkActiveClass: 'selected',
  routes: [
    {
      path: '/',
      redirect: '/apps/presentations',
    },
    {
      path: '/apps',
      component: () => import('./components-v2/home/Home.vue'),
      children: [
        {
          path: 'presentations',
          name: 'Presentations',
          meta: { title: 'My Presentations' },
          component: () => import('./components-v2/my-presentations/MyPresentations.vue'),
        },
        {
          path: 'shared-presentations',
          name: 'SharedWithMe',
          meta: { title: 'Shared With Me' },
          component: () => import('./components-v2/my-presentations/MyPresentations.vue'),
        },
        {
          path: 'presentations/folders/:folderId',
          name: 'FolderDetail',
          meta: { title: 'My Presentations' },
          component: () => import('./components-v2/my-presentations/MyPresentations.vue'),
        },
        {
          path: 'template-library',
          name: 'TemplateLibrary',
          meta: { title: 'Templates' },
          component: () => import('./components-v2/template-library/TemplateLibrary.vue'),
        },
        {
          path: 'template-library/category/:id',
          name: 'TemplateCategory',
          component: () => import('./components-v2/template-library/CategoryDetail.vue'),
        },
        {
          path: 'team/workspace',
          name: 'Team',
          meta: { title: 'My Team' },
          component: () => import('./components-v2/my-presentations/MyPresentations.vue'),
        },
        {
          path: 'team/members',
          name: 'TeamMember',
          meta: { title: 'My Team' },
          component: () => import('./components-v2/my-team/Team.vue'),
        },
        {
          path: 'user-profile',
          name: 'UserProfile',
          meta: { title: 'My Profile' },
          component: () => import('./components-v2/my-profile/MyProfile.vue'),
        },
        {
          path: 'billing',
          name: 'BillingList',
          meta: { title: 'Payment' },
          component: () => import('./components-v2/billing/BillingList.vue'),
        },
        {
          path: 'billing/:id',
          name: 'BillingDetail',
          meta: { title: 'Billing detail' },
          component: () => import('./components-v2/billing/BillingDetail.vue'),
        },
        {
          path: 'community',
          name: 'Community',
          meta: { title: 'Community' },
          component: () => import('./components-v2/community/UserCommunity.vue'),
        },
        {
          path: 'upgrade/:id',
          name: 'Upgrade',
          meta: { title: 'Upgrade Plan' },
          component: () => import('./components-v2/my-plan/UpgradePlan.vue'),
        },
        {
          path: 'user-plan',
          name: 'UserPlan',
          meta: { title: 'My Plan' },
          component: () => import('./components-v2/my-plan/UserPlan.vue'),
        },
        {
          path: 'user-plan/cancel',
          name: 'UserCancelSub',
          meta: { title: 'Cancel Subscription' },
          component: () => import('./components-v2/my-plan/UserCancelSub.vue'),
        },
        {
          path: 'white-label',
          name: 'WhiteLabel',
          meta: { title: 'White Label configuration' },
          component: () => import('./components-v2/white-label/WhiteLabel.vue'),
        },
        {
          path: 'referral',
          name: 'Referral',
          meta: { title: 'Refer a Friend' },
          component: () => import('./components-v2/referral/Referral.vue'),
        },
      ],
    },
    {
      path: '/demo',
      name: 'DemoPresentation',
      component: () => import('./components-v2/presentation-editor/demo-mode/DemoPage.vue'),
    },
    {
      path: '/pages/sso',
      name: 'SSO',
      meta: { title: 'Login with SSO' },
      component: () => import('./components-v2/sso/SSO.vue'),
    },
    {
      path: '/auth',
      name: 'Auth',
      meta: { title: 'Login' },
      component: () => import('./components-v2/common/auth/Auth.vue'),
    },
    {
      path: '/pages',
      redirect: '/pages/register',
    },
    {
      path: '/apps/community',
      name: 'Community',
    },

    {
      path: '/pages/login',
      name: 'Login',
      meta: { title: 'Login' },
      component: () => import('./components-v2/login/LoginV2.vue'),
    },
    {
      path: '/pages/register',
      name: 'Register',
      meta: { title: 'Create your account' },
      component: () => import('./components-v2/register/RegisterV2.vue'),
    },
    {
      path: '/pages/forgot-password',
      name: 'ForgotPassword',
      meta: { title: 'Forgot password' },
      component: () => import('./components-v2/forgot-password/ForgotPassword.vue'),
    },
    {
      path: '/pages/token',
      name: 'Token',
      component: () => import('./components-v2/token/Token.vue'),
    },
    {
      path: '/pages/error-404',
      name: 'Error404',
      meta: { title: 'Page not found' },
      component: () => import('./components-v2/404/Error404.vue'),
    },
    {
      path: '*',
      redirect: '/pages/error-404',
    },
    {
      path: '/presentation/:id',
      name: 'PresentationDetail',
      component: () => import('./components-v2/presentation-editor/PresentationEditor.vue'),
    },
    {
      path: '/presentation/:id/backstage',
      name: 'PresentationBackstage',
      component: () => import('./components-v2/presentation-editor/PresentationEditor.vue'),
    },
    {
      path: '/share/:id',
      name: 'PresentationShare',
      component: () => import('./components-v2/presentation-editor/PresentationEditor.vue'),
    },
    {
      path: '/template/:shareCode',
      name: 'TemplatePreview',
      component: () => import('./components-v2/template/TemplatePreview.vue'),
    },
    {
      path: '/live-demo/',
      name: 'PresentationPlayDemo',
      component: () => import('./components-v2/presentation-play-demo/PresentationPlayDemo.vue'),
    },
    {
      path: '/save-presentation/',
      name: 'SavePresentation',
      component: () => import('./components-v2/save-presentation/SavePresentation.vue'),
    },
  ],
}

if (Config.env === 'local') {
  configRouter.base = process.env.BASE_URL
}

const router = new Router(configRouter)

router.beforeEach((to, from, next) => {
  const {
    name,
    query,
    params,
    redirectedFrom,
    fullPath,
    path,
  } = to

  if (to.meta && to.meta.title) {
    util.setDocumentTitle(to.meta.title)
  }

  const token = cookie.getValue('ahaToken')
  const url = `${document.location.origin}${fullPath}`

  store.commit('SET_ROUTE', to)

  if (query.tracking !== 'false') {
    util.gaTrackPageView(fullPath, name)
  }

  mixpanelUtils.track(`PV > ${name}`, {
    fullPath,
  })

  if (window.sendinblue) {
    window.sendinblue.page(name, {
      ma_url: url,
      title: name,
      ma_title: name,
      ma_path: fullPath,
    })
  }

  const isEmbed = util.getParamValue('embedded')

  const NO_CHAT_ROUTES = ['2022WrapUp', 'PresentationShare', 'PresentationPlayDemo', 'PresentationBackstage']
  if (!isEmbed && NO_CHAT_ROUTES.indexOf(name) < 0) {
    zoho.init()
  }
  const isGuest = cookie.getValue('aha-guest-user')
  if (token) {
    Vue.http.headers.common.Authorization = `Bearer ${token}`
  }
  const publicRoutes = [
    'Login',
    'Token',
    'Register',
    'ForgotPassword',
    'PresentationShare',
    'DemoPresentation',
    'Auth',
    'SSO',
    'PresentationPlayDemo',
    'SavePresentation',
  ]
  const openRoutesForGuest = [
    ...publicRoutes,
    'PresentationDetail',
  ]

  if (publicRoutes.indexOf(name) > -1) {
    next()
    return
  }

  // if logged in as normal user, open all routes
  if (token && !isGuest) {
    next()
    return
  }
  if (isGuest || name === '2022WrapUp') {
    if (openRoutesForGuest.indexOf(name) > -1) {
      next()
      return
    }
    router.push({ path: '/pages/register', query })
    return
  }

  if (name === 'Upgrade') {
    if (params.id === 'essential-monthly') {
      query.content = 'essential_monthly'
    }

    if (params.id === 'essential-yearly') {
      query.content = 'essential_annually'
    }

    if (params.id === 'pro-monthly') {
      query.content = 'pro_monthly'
    }

    if (params.id === 'pro-yearly') {
      query.content = 'pro_annually'
    }

    if (query.content) {
      query.source = 'pricing'
    }
  }

  // user is redirected to login/signup from another page
  // and we want to redirect the user back to that previous page after login/signup
  // Because of AHA-6861, we will only open to specific routes when needed
  if (path === '/apps/template-library') {
    query.redirect = path
  }

  // https://ahaslides.atlassian.net/browse/AHA-3127
  // if user without account is invited, redirect to signup
  if ((redirectedFrom && (redirectedFrom === '/' || redirectedFrom.indexOf('/?') === 0)) || query['invite-code']) {
    router.push({ path: '/pages/register', query })
    return
  }
  router.push({ path: '/pages/login', query })
})

router.afterEach(() => {
  // wait until the route is loaded before removing inital polling loader
  // to avoid brief blank screen
  util.removeInitialLoader()
})

router.onError(() => {
  store.dispatch('setIsServerConnectableAction', false)
})

export const disallowedRoutesForSkoletube = [
  'Team',
  'UserProfile',
  'UserPlan',
  'UserCancelSub',
  'Upgrade',
  'BillingList',
  'BillingDetail',
  'WhiteLabel',
]

export default router
